import {type AppreciationKey, getAppreciationId} from "../../redux/appreciationsUtil";
import AppreciationInputText from "./AppreciationInputText";
import {resolveAppreciationId, useAppreciationVisible} from "./appreciationHooks";

interface AppreciationInputFormFieldProps {
    /** option1: provide appreciation key */
    appreciationKey?: AppreciationKey;
    /** option2: provide appreciation page (and tab and section), to calculate key */
    page?: string;
    tab?: string;
    section?: string;
    /** Displayed label */
    label: string;
    /** Displayed placeholder */
    placeholder?: string;
}

/**
 * Wrapper for AppreciationInputText, styled as fields for use inside an input block.
 */
export default function AppreciationInputFormField({
    appreciationKey,
    page,
    tab,
    section,
    label,
    placeholder,
}: AppreciationInputFormFieldProps) {
    const effectiveAppreciationKey = resolveAppreciationId(appreciationKey, page, tab, section);
    const appreciationId = getAppreciationId(effectiveAppreciationKey);
    const appreciationVisible = useAppreciationVisible(effectiveAppreciationKey);

    if (!appreciationVisible) {
        // Appreciation UI requires permission, except for the always-visible exception fields (#18607)
        return null;
    }

    return (
        <div key={`appreciationField_${appreciationId}`} className="field p-inputtext-sm text-sm">
            <label htmlFor={`appreciationInput_${appreciationId}`}>{label}</label>
            <div className="w-full">
                <AppreciationInputText
                    appreciationKey={appreciationKey}
                    page={page}
                    tab={tab}
                    section={section}
                    autoFocus={false}
                    placeholder={placeholder}
                    showToast={false}
                />
            </div>
        </div>
    );
}
